import { get, del } from './requests.js'

export const getLogsEnum = (field) => get(['changelogs', 'enum', field], { transformPayload: true })

export const getEntityLogs = ({ collection, id }) =>
  get(
    ['changelogs'],
    { removeTrailingSlash: true },
    { collection, id, sort: 'created_at,-1', limit: 100 }
  )

export const deleteLog = (_id) => del(['changelogs', _id])
